/**
 * @file Product Page
 * @author zhenglujie(zhenglujie@baidu.com))
 * Copyright (c) 2019-06-04 Baidu
 */

import React from 'react';
import {Table, Button, Modal, Carousel} from 'antd';
import {connect} from 'react-redux';
import banner from '../../img/sever-banner.png';
import {Link} from 'react-router-dom';
import alertIcon from '../../img/icon-alert.png';
import {getDwzConsoleUrl} from '../../common/util';
// import {getLoginUrl} from '../../common/util';
import {setCurrentPage} from '../../actions/generalAction';
import {billingPackageOfQuarter, billingPackageOfMonth, billingPackageOfYear,
    billingPackageOfYear2} from '../../common/package';
import './index.less';

class Product extends React.Component {
    state = {
        visible: false
    }
    linkToPrice() {
        this.props.dispatch(setCurrentPage('price'));
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    linkToCreateAdvancedReport() {
        localStorage.setItem('page', 4);
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    jumpDemo() {
        window.open('https://tongji.baidu.com/web/demo/overview/index?siteId=5503017', '_blank');
    }
    handleBuyClick() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '产品服务', 'product_click_buy', '点击购买']);
        // 如果没有登录，提示登录
        if (!this.props.userName) {
            return this.showModal();
        }
        window.open(getDwzConsoleUrl(), '_blank');
    }
    hideModal() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '登录框提示', 'loginguide_click_cancel', '点击取消']);
        this.setState({
            visible: false
        });
    }
    showModal() {
        this.setState({
            visible: true
        });
    }
    goLogin() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '登录框提示', 'loginguide_click_contiue', '点击前往登录']);
        this.setState({
            visible: false
        });
        window.open('https://console.bce.baidu.com/dwz/?channel=portal', '_blank');
        // window.location.href = getLoginUrl();
    }
    linkToCece(){
        /* eslint-disable */
        _hmt.push(['_trackEvent', '产品服务页', 'product_click_cece', '产品服务页跳转百度测测']);
    }
    render() {
        const settings = {
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            vertical: true,
        };
        const billingRules = {
            head: [{
                title: '基础定价',
                dataIndex: 'basicPrice',
                key: 'basicPrice'
            },
            {
                title: '跳转消耗/次',
                dataIndex: 'jumpConsume',
                key: 'jumpConsume'
            },
            {
                title: '创建消耗/个（1年有效）',
                dataIndex: 'createConsumeOfYear',
                key: 'createConsumeOfYear',
                render: (text, _) => (
                    <span>
                        <span className="activity">&nbsp;&nbsp;1点</span>
                    </span>
                )
            },
            {
                title: '创建消耗/个（长期有效）',
                dataIndex: 'createConsumeOfLongTerm',
                key: 'createConsumeOfLongTerm',
                render: (text, _) => (
                    <span>
                        <span className="activity">&nbsp;&nbsp;2点</span>
                    </span>
                )
            }],
            body: [{
                key: 1,
                basicPrice: '10元/10000点',
                jumpConsume: '1点',
                createConsumeOfYear: '10点',
                createConsumeOfLongTerm: '20点'
            }]
        };
        const freeAllowance = {
            head: [{
                title: '免费额度',
                dataIndex: 'freeLimit',
                key: 'freeLimit'
            },
            {
                title: '有效期',
                dataIndex: 'validityPeriod',
                key: 'validityPeriod'
            },
            {
                title: '月创建限额',
                dataIndex: 'freeLimitOfMonth',
                key: 'freeLimitOfMonth'
            }],
            body: [{
                key: 1,
                freeLimit: '100点',
                validityPeriod: '1个月',
                freeLimitOfMonth: '5个（长期有效）'
            }]
        };
        const payByVolumn = {
            head: [{
                title: '计费方式',
                dataIndex: 'billingMethod',
                key: 'billingMethod'
            },
            {
                title: '周期',
                dataIndex: 'cycle',
                key: 'cycle'
            },
            {
                title: '定价',
                dataIndex: 'price',
                key: 'price'
            }],
            body: [{
                key: 1,
                billingMethod: '按量付费',
                cycle: '按小时结算',
                price: '10元/10000点'
            }]
        };
        const billingRuleDesc1 = '百度短网址采用点数来计费，所有短网址用户每月免费享有100点。';
        const billingRuleDesc2 = '系统根据实际点数消耗来扣除账户中的点数。账户剩余点数不足请登录百度云购买套餐包，欠费后将无法创建短网址，'
            + '已创建的短网址将出现延迟跳转。';
        const billingRuleDescRed = '短网址跳转一次消耗1个点；创建一条一年有效的短网址消耗1个点；创建一条长期有效的短网址消耗2个点。';
        const payTipContent = '【高级报表】正式上线啦！帮你真正了解你的客户，提高转化率！付费用户可免费试用7天，购买一年期订阅套餐更可赠送高级报表！';
        const ceceTipContent = '【产品推荐】百度测测，提供专业的网站服务质量监控！';
        const ImportantNoticeOne = '亲爱的短网址用户：';
        // const ImportantNoticeTwo = '为满足国家相关监管部门关于链接跳转内容的监管要求，打击通过短网址服务进行涉嫌诈骗、'
        //     + '涉黄涉暴的非法行为，短网址服务将开展对正在使用的匿名短网址的审查及下线、对短网址服务中违规短链进行清理。'
        //     + '请各位用户遵守相关规定，共同维护良好的网络环境。';
        const ImportantNoticeThree = '如果您正在使用的短网址是8位以下并未登记过企业信息，请您自行备份重要数据。'
            + '需要继续使用短网址服务，请您通过百度智能云';
        // const ImportantNoticeFour = '• 如果您是以个人名义注册账号的企业，可进行';
        // const ImportantNoticeFive = '• 已创建的短网址目前仍可正常跳转。';
        // const ImportantNoticeSix = '• 如果您不再继续使用短网址，可在';
        // const ImportantNoticeSeven = '• 企业用户： ';
        // const ImportantNoticeEight = '• 短网址将加强内容审核，因此可能造成创建短网址失败。可';
        // const ImportantNoticeNine = '感谢各位用户与我们共同建设更好的互联网环境，由此带来的不便敬请谅解！';
        // const ImportantNoticeTen = '如有任何疑问，可联系我们';
        const payByVolumnDec = '系统优先使用每个月的免费额度，免费额度用完后，计费会优先抵扣套餐包，超出部分按照'
            + '按量付费的方式，即按10元/万点的单价扣除账户余额。';
        return (
            <div className="product-container">
                <div className="dwz-banner" >
                        <div className='dwz-banner-box-top'>
                            <img src={banner} />
                            <div className='banner-msg'>
                                <p>百度短网址</p>
                                <div className='des-msg'>
                                    <p>强大的多功能API，简单易用，质量高</p>
                                    <p>百度云提供强技术支持，99.9% SLA服务稳定</p>
                                    <p>安全可靠的校验机制，提高链接安全性</p>
                                    {/* <p>高级报表，精准的数据统计分析</p> */}
                                </div>
                                <span>
                                    <Button onClick={() => { this.handleBuyClick(); }}
                                        className="buy-btn"
                                        type="primary">点击购买</Button>
                                    <Link to="/console/price" onClick={() => this.linkToPrice()}>产品价格></Link>
                                </span>
                            </div>
                        </div>
                        <Carousel {...settings}>
                        {/* <div className="tip">
                            <p className="activity">
                                <img src={alertIcon} style={{ height: 24, width: 24 }} />
                                {payTipContent}
                                <Link to='/console/advanced_report' >马上了解{'>'}</Link>
                            </p>
                        </div> */}
                        <div className="tip">
                            <p className="activity">
                                <img src={alertIcon} style={{ height: 24, width: 24 }} />
                                {ceceTipContent}
                                <a href="https://cece.baidu.com/home" target="_blank" onClick={() => this.linkToCece()} > 马上了解 {'>'}</a>
                            </p>
                        </div>
                        </Carousel>
                        <div className="ImportantNotice">
                            <h2 className="title" style={{ marginTop:'40px' }}>重要通知</h2>
                            <div style={{margin: '30px 0'}} >
                                <p style={{textIndent: '.5em'}}>{ImportantNoticeOne}</p>
                                <p style={{textIndent: '2.5em'}}>
                                    <span>为满足国家相关监管部门关于链接跳转内容的监管要求，打击通过短网址服务进行涉嫌诈骗、</span>
                                    <span>涉黄涉暴的非法行为，短网址服务将开展<strong>对正在使用的匿名短网址的审查及下线、对短网址服务中违规短链进行清理。</strong></span>
                                    <span>请各位用户遵守相关规定，共同维护良好的网络环境。</span>
                                </p>
                                {/* <p style={{textIndent: '2.5em'}}>{ImportantNoticeThree}</p> */}
                                <p style={{textIndent: '2.5em'}}>{ImportantNoticeThree}
                                    <a href="https://cloud.baidu.com/doc/UserGuide/s/ejwvy3fo2" target="_blank">注册账号</a>
                                    进行<a href="https://cloud.baidu.com/doc/UserGuide/s/3kuwcaomi" target="_blank">企业实名认证</a>
                                    后，进入短网址服务控制台使用。其他问题，您也可以直接
                                    <Button className="consultation" type="primary">
                                        <a href="https://ticket.bce.baidu.com/#/ticket/create~productId=188&questionId=706&channel=2" target="_blank">联系我们</a>
                                    </Button>
                                </p>
                                <p style={{textIndent: '2.5em'}}>
                                    使用前，请一定查阅常见问题<a href="https://dwz.cn/console/faq" target="_blank">https://dwz.cn/console/faq</a>
                                </p>
                                <p style={{textIndent: '2.5em'}}>
                                    感谢您的配合与理解。
                                </p>
                                {/* <p style={{textIndent: '5em'}}>{ImportantNoticeFour}
                                    <a href="https://cloud.baidu.com/doc/UserGuide/s/Ajwvy3ckg" target="_blank">企业账号认证</a>。</p>
                                <p style={{textIndent: '5em'}}>{ImportantNoticeFive}</p>
                                <p style={{textIndent: '5em'}}>
                                    {ImportantNoticeSix}
                                    <a href="https://ticket.bce.baidu.com/?_=1587443699892&_/#/ticket/create~productId=64&questionId=399&channel=2" target="_blank">工单</a>
                                    内申请退款。
                                </p>
                                <p style={{textIndent: '2.5em'}}>{ImportantNoticeSeven}</p>
                                <p style={{textIndent: '5em'}}>
                                    {ImportantNoticeEight}
                                    <a href="https://ticket.bce.baidu.com/#/ticket/create~productId=188&questionId=898" target="_blank">联系我们</a>
                                    进行安全审核，通过审核后，即可创建短网址。
                                </p>
                                <p style={{textIndent: '.5em'}}>{ImportantNoticeNine}</p>
                                <p style={{textIndent: '.5em'}}>
                                    {ImportantNoticeTen}
                                    <Button className="consultation" type="primary">
                                        <a href="https://ticket.bce.baidu.com/#/ticket/create~productId=188&questionId=706&channel=2" target="_blank">客服咨询</a>
                                    </Button>
                                </p> */}
                            </div>
                        </div>
                </div>
                <div className="billing-content">
                    <h2 className="title">计费规则</h2>
                    <p>{billingRuleDesc1}<span className="activity">{billingRuleDescRed}</span>{billingRuleDesc2}</p>
                    <Table columns={billingRules.head}
                        dataSource={billingRules.body}
                        pagination={false} bordered={true} />
                    {/* <h2 className="title">免费额度</h2>
                    <p>所有用户每月免费享有100点，过期作废。免费用户每个月可创建不超过5个长期有效的短网址。</p>
                    <Table columns={freeAllowance.head}
                        dataSource={freeAllowance.body}
                        pagination={false} bordered={true} /> */}
                    <h2 className="title">按量付费</h2>
                    <p>{payByVolumnDec}</p>
                    <Table columns={payByVolumn.head}
                        dataSource={payByVolumn.body}
                        pagination={false} bordered={true} />
                    <h2 className="title">套餐包</h2>
                    <Table columns={billingPackageOfQuarter.head}
                        dataSource={billingPackageOfQuarter.body}
                        pagination={false} bordered={true} />
                    {/* 短网址包月套餐包 */}
                    <Table columns={billingPackageOfMonth.head}
                        dataSource={billingPackageOfMonth.body}
                        pagination={false} bordered={true} />
                    {/* 短网址包年套餐包 */}
                    <Table columns={billingPackageOfYear.head}
                        dataSource={billingPackageOfYear.body}
                        pagination={false} bordered={true} />

                    {/* 短网址包年套餐包 */}
                    <Table columns={billingPackageOfYear2.head}
                        dataSource={billingPackageOfYear2.body}
                        pagination={false} bordered={true} />
                    {/* <h2 className="title">高级报表</h2>
                    <p>高级报表为百度短网址的特色增值服务，依托百度统计多年的大数据积累，为您提供全面、精准的用户数据统计分析，帮助您用数据驱动业务增长，提高转化率。</p>
                    <p>高级报表功能与百度短网址无缝对接，无需单独埋点。更多详情请参考<Link to='/console/advanced_report'> 高级报表使用说明></Link></p>
                    <p>套餐包付费用户可免费试用7天，购买一年期订阅可赠送高级报表！<Link to="/console/advanced_report" onClick={() => this.linkToCreateAdvancedReport()}>立即申请高级报表></Link></p>
                    <Button className="buy-btn" type="primary" style={{ marginBottom: '20px' }} onClick={() => { this.jumpDemo(); }}>
                        点击一下，体验demo
                    </Button> */}
                    {/* 高级报表 */}
                    {/* <Table columns={advancedReport.head}
                        dataSource={advancedReport.body}
                        pagination={false} bordered={true} /> */}
                    <Modal
                        title="登录提示"
                        visible={this.state.visible}
                        onOk={() => this.goLogin()}
                        onCancel={() => this.hideModal()}
                        okText="前往登录"
                        cancelText="取消">
                        为了保证您的网址安全，并提供更强大的个性化功能，请登录后继续使用百度短网址。谢谢您的支持！
                    </Modal>
                </div>
            </div>
        );
    }
}
export default connect(state => ({
    currentPage: state.currentPage,
    userName: state.userName
}))(Product);
